// extracted by mini-css-extract-plugin
export default {"noResultsContainer":"productList_noResultsContainer__FH6S1"};